





























































import Vue from 'vue'
import BusinessIcon from '@/components/Businesses/BusinessIcon.vue'
import Loader from '@/components/Global/Loader.vue'

export default Vue.extend({
  name: 'BusinessDetails',
  props: { businessDetails: Object, loading: Boolean },
  components: { Loader, BusinessIcon }
})
